import { useState, useEffect } from 'react';

const useResizeObserver = (ref) => {
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    useEffect(() => {
        if (!ref?.current) return;

        const observedElement = ref.current; // Store the current ref value in a local variable

        const resizeObserver = new ResizeObserver(entries => {
            if (entries[0]) {
                setDimensions({
                    width: entries[0].contentRect.width,
                    height: entries[0].contentRect.height,
                });
            }
        });

        resizeObserver.observe(observedElement);

        return () => {
            resizeObserver.unobserve(observedElement); // Use the stored variable here
        };
     
    }, [ref]);

    return dimensions;
};

export default useResizeObserver;
